export const BASE_URL = "https://blen-dqwl.onrender.com";
